import Icon from './Icon';
import { IconProps, IconValueProps } from './types';

export type { IconProps, IconValueProps };
export default Icon;
